import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { ApiProvider } from "./api/ApiProvider";
import { AuthProvider } from "./auth/AuthContext";
import "./styles/global.css";
import { ThemeProvider } from "./theme/ThemeContext";
import { ToastProvider } from "./toast/ToastContext";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // The UI is event-driven, not polled (charter P-1) — real-time
      // correctness comes from the event subscription seam
      // (useContainerEventsSubscription), not from refetch-on-focus.
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ApiProvider>
        <ThemeProvider>
          <ToastProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ToastProvider>
        </ThemeProvider>
      </ApiProvider>
    </QueryClientProvider>
  </StrictMode>,
);
